import styled from 'styled-components';

const AwardDescription = styled.div`
  font-size: 12px;
  line-height: 1.83;
  color: ${props => props.theme.color.white};
`;

export default AwardDescription;